import { Component, Input, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss'],
  standalone: false
})
export class ConfirmDialogComponent {
  activeModal = inject(NgbActiveModal);

  @Input() title = 'Confirm';
  @Input() message = 'Are you sure?';
  @Input() btnOkText = 'Confirm';
  @Input() btnCancelText = 'Cancel';

  decline() {
    this.activeModal.close(false);
  }

  accept() {
    this.activeModal.close(true);
  }
}


